import { render, staticRenderFns } from "./FormModalDischargeBeds.vue?vue&type=template&id=5a783b34&"
import script from "./FormModalDischargeBeds.vue?vue&type=script&lang=js&"
export * from "./FormModalDischargeBeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports